export const MAX_PRODUCTLINE_NAME_LENGTH = 50;

const ILLEGAL_EXPORT_NAME_CHARS = [
  "\\",
  "/",
  ":",
  "*",
  "?",
  '"',
  "<",
  ">",
  "|",
];

/**
 * Validates a product line export name for use as a download filename base.
 * Mirrors ReactCore5 FileUtility.GetExportNameValidationError.
 * @returns Null if valid; otherwise an error message.
 */
export function getExportNameValidationError(
  exportName: string | null | undefined
): string | null {
  if (exportName == null || exportName.trim() === "") {
    return "Product Line export name cannot be empty or null.";
  }

  if (exportName.length > MAX_PRODUCTLINE_NAME_LENGTH) {
    return `Product Line export name '${exportName}' is longer than ${MAX_PRODUCTLINE_NAME_LENGTH} characters.`;
  }

  for (const char of ILLEGAL_EXPORT_NAME_CHARS) {
    if (exportName.includes(char)) {
      return `Product Line export name '${exportName}' contains illegal character '${char}'.`;
    }
  }

  return null;
}

/**
 * Validates a product line display name.
 * Mirrors ReactCore5 FileUtility.GetProductlineNameValidationError.
 * @returns Null if valid; otherwise an error message.
 */
export function getProductlineNameValidationError(
  name: string | null | undefined
): string | null {
  if (name == null || name.trim() === "") {
    return "Product Line name cannot be empty or null.";
  }

  if (name.length > MAX_PRODUCTLINE_NAME_LENGTH) {
    return `Product Line name '${name}' is longer than ${MAX_PRODUCTLINE_NAME_LENGTH} characters.`;
  }

  return null;
}
